const FILTER_BAR_ACTIONS = {
  selectStatusesFilter: 'SELECT_STATUS_FILTER',
  deselectStatusesFilter: 'DESELECT_STATUS_FILTER',
};

export default FILTER_BAR_ACTIONS;
